// src/App.jsx
import React from 'react';
import { useLanguage } from './hooks/useLanguage';
import { translations } from './data/translations';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import BankCardsSection from './components/BankCardsSection';
import StatsSection from './components/StatsSection';
import TestimonialsSection from './components/TestiomonialsSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

const App = () => {
  const { language, changeLanguage } = useLanguage();
  const t = translations[language];

  // Smooth scroll behavior for navigation links
  React.useEffect(() => {
    const handleSmoothScroll = (e) => {
      const href = e.target.getAttribute('href');
      if (href && href.startsWith('#')) {
        e.preventDefault();
        const target = document.querySelector(href);
        if (target) {
          const headerOffset = 80;
          const elementPosition = target.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }
    };

    document.addEventListener('click', handleSmoothScroll);
    return () => document.removeEventListener('click', handleSmoothScroll);
  }, []);

  return (
    <div 
      className={`min-h-screen ${language === 'ar' ? 'font-arabic' : 'font-sans'}`} 
      dir={language === 'ar' ? 'rtl' : 'ltr'}
    >
      {/* Navigation Header */}
      <Header language={language} changeLanguage={changeLanguage} t={t} />
      
      {/* Main Content Sections */}
      <main>
        <HeroSection language={language} t={t} />
        <FeaturesSection language={language} t={t} />
        <BankCardsSection language={language} t={t} />
        {/* <StatsSection language={language} t={t} /> */}
        {/* <TestimonialsSection language={language} t={t} /> */}
        <CTASection language={language} t={t} />
      </main>
      
      {/* Footer */}
      <Footer language={language} t={t} />
    </div>
  );
};

export default App;